var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side_buttons",class:{ active: _vm.isActive },on:{"click":_vm.openAction}},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.submit('edit')}}},[_vm._v("Edit")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"more_btn"},[_c('i',{staticClass:"fa-solid fa-angle-right"})])
}]

export { render, staticRenderFns }